import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SkinFlow from "@/pages/SkinFlow";
import Admin from "@/pages/Admin";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<SkinFlow />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="*" element={<SkinFlow />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
